import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { statusAlerts } from '@app/library/panes/my-library-content/constants';
import { AlertModule } from '@core/components/alert/alert.module';
import { OnUiButtonModule } from 'onclass-ui';

@Component({
  selector: 'app-status-change-alert',
  templateUrl: './status-change-alert-alert.component.html',
  standalone: true,
  imports: [LocaleSharedModule, AlertModule, OnUiButtonModule],
})
export class StatusChangeAlertComponent {
  @Input() type: string;
  @Output() closed = new EventEmitter<boolean>();
  @Output() save = new EventEmitter<boolean>();

  public get details() {
    return statusAlerts.find((el) => el.action === this.type);
  }

  public onClose() {
    this.closed.emit(true);
  }

  public onSave() {
    this.save.emit(true);
  }
}
